/**
 * Copyright 2021-2022 Highway9 Networks Inc.
 */
// biome-ignore lint/style/noRestrictedImports: typed wrappers re-export from react-redux
import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from "react-redux";
import type { RootState, AppDispatch, AppStore } from ".";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Read state at event time without subscribing - for values only needed inside
// handlers, where a subscription would re-render on every websocket flush.
export const useAppStore: () => AppStore = useStore;
